export const phoneRegExp = /^\([1-9]{2}\) 9{0,1}[2-9]{1}\d{3}-\d{4}$/

export const strongPasswordRegExp =
  /^(?=.*[A-Z])(?=.*[!@#$&%><*])(?=.*\d)(?=.*[a-z]).{8,}$/

export const mediumPasswordRegExp = new RegExp(
  '' +
    // mininum: 1 upper and 1 lower, 1 number and length 8,
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}/.source +
    // mininum: 1 upper and 1 lower, 1 special char and length 8,
    /|(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&%><*]).{8,}/.source +
    // mininum: 1 special char, 1 number and length 8,
    /|(?=.*[!@#$&%><*])(?=.*\d).{8,}/.source +
    // mininum: 1 upper and 1 lower, 1 symbol and 1 number
    /|(?=.*[A-Z])(?=.*[a-z]).{1,}(?=.*[!@#$&%><*]).{1,}(?=.*\d).{1,}$/.source,
)

export const validatedEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const validateMotherName =
  /^([a-zA-Zá-źÁ-Ź]{3,})+(?:\s[a-zA-Zá-źÁ-Ź]+)+$/
